// src/components/ConfirmDialog.js
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
} from "@mui/material";
import WarningIcon from "@mui/icons-material/Warning";

export default function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  title = "Confirm Delete",
  message = "Are you sure you want to delete this item?",
  confirmText = "Delete",
  cancelText = "Cancel",
  itemName = null, // Optional: name of item being deleted
  severity = "error", // "error" | "warning" | "info"
}) {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
        },
      }}
      sx={{
        zIndex: 1400, // Higher than default Dialog z-index (1300) to appear above other dialogs
      }}
    >
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <WarningIcon
          color={severity}
          sx={{ fontSize: 28 }}
        />
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {message}
          {itemName && (
            <Box
              component="span"
              sx={{
                fontWeight: 600,
                color: "text.primary",
                display: "block",
                mt: 1,
              }}
            >
              {itemName}
            </Box>
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        {cancelText && (
          <Button onClick={onClose} variant="outlined" disableRipple>
            {cancelText}
          </Button>
        )}
        <Button
          onClick={handleConfirm}
          color={severity}
          variant="contained"
          autoFocus
          disableRipple
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}